import React, {Fragment, useEffect, useRef} from 'react';

import {format, parseISO} from 'date-fns';
import ModalDatePicker from 'presentation/components/ModalDatePicker';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';

import {useConsultRefundDateFilter} from './hooks/useConsultRefundDateFilter';
import {StyledButton} from './styles';
import {ConsultRefundDateFilterProps} from './types';

const {applyFilters} = translations['pt-br'].commons;

export function ConsultRefundDateFilter(props: ConsultRefundDateFilterProps) {
	const {openDatePickerState, setOpenDatePickerState, formatted, handleClearDates} =
		useConsultRefundDateFilter(props.firstDate, props.secondDate, props.handleFilter);

	const lastOpenRequest = useRef(props.datePickerOpenRequest ?? 0);

	useEffect(() => {
		const current = props.datePickerOpenRequest ?? 0;
		if (current > lastOpenRequest.current) {
			setOpenDatePickerState(true);
		}
		lastOpenRequest.current = current;
	}, [props.datePickerOpenRequest, setOpenDatePickerState]);

	return (
		<Fragment>
			<StyledButton
				variant="text"
				size="small"
				onClick={() => setOpenDatePickerState(true)}
				endIcon={<Icon name="edit" size={20} />}
				data-tag-id={props.dataTagId?.openButton}>
				{formatted}
			</StyledButton>
			<ModalDatePicker
				dataTagId={props.dataTagId}
				externalOpen={openDatePickerState}
				onAbandonModal={() => setOpenDatePickerState(false)}
				currentFirstDate={props.firstDate ? parseISO(props.firstDate) : new Date()}
				currentSecondDate={props.secondDate ? parseISO(props.secondDate) : new Date()}
				selectFirstDate={() => null}
				selectSecondDate={() => null}
				selectDates={date => {
					const {firstDate, secondDate} = date;
					if (!firstDate || !secondDate) return;

					props.handleFilter({
						dtInicio: format(firstDate, 'yyyy-MM-dd'),
						dtFim: format(secondDate, 'yyyy-MM-dd'),
					});

					setOpenDatePickerState(false);
				}}
				showClearButton={true}
				onClearDates={handleClearDates}
				hideOpenButton={true}
				isSecondDateOptional
				adjustDateInterval={false}
				customLabelConfirmButton={applyFilters}
				showNextMonthDay={false}
				showPrevMonthDay={false}
				shouldHaveDateIntervals={true}
				includeDateIntervals={{
					start: new Date(1900, 0, 1),
					end: new Date(),
				}}
			/>
		</Fragment>
	);
}
